import Image from "next/image";
import Link from "next/link";
import React from "react";

const LogoHeader = ({ className = "md:px-[10px]" }: { className?: string }) => {
  return (
    <header
      className={`p-5 md:pt-12 md:pb-[10px] flex justify-between md:gap-[10px] ${className}`}
    >
      <Link href="/">
        <Image
          src="https://cdn.buttercms.com/Wb3ZvB93TvmJmnRdnzRh"
          alt="Callia Logo"
          width={136}
          height={38}
          className="text-primary"
        />
      </Link>
    </header>
  );
};

export default LogoHeader;
